import { useParams } from 'react-router-dom';
import DynamicComponentLoader from './DynamicComponentLoader';
import pages from '../config/pages.json';

export function Page() {
    const { pageId } = useParams();
    const page = pages.find((page) => page.id === pageId);

    return <DynamicComponentLoader componentName={page?.component} />
}
